import React from 'react';
import { FaAws, FaJava, FaCertificate, FaNetworkWired } from 'react-icons/fa';

const certs = [
  {
    title: 'AWS Certified Solutions Architect',
    issuer: 'Amazon Web Services',
    level: 'Associate',
    icon: FaAws,
  },
  {
    title: 'Oracle Certified Professional',
    issuer: 'Oracle',
    level: 'Java SE 8 Programmer',
    icon: FaJava,
  },
  {
    title: 'SAFe® 4 Certified Practitioner',
    issuer: 'Scaled Agile',
    level: 'Practitioner',
    icon: FaCertificate,
  },
  {
    title: 'Cisco Certified Network Associate',
    issuer: 'Cisco',
    level: 'CCNA',
    icon: FaNetworkWired,
  },
];

const Certifications = () => {
  return (
    <section name='certs' className='w-full py-24 sm:py-32 bg-bg'>
      <div className='container-narrow'>
        <p className='section-eyebrow'>04. Credentials</p>
        <h2 className='section-title'>Certifications</h2>
        <div className='w-12 h-1 bg-accent rounded-full mb-12' />

        <div className='grid sm:grid-cols-2 gap-5'>
          {certs.map((c) => {
            const Icon = c.icon;
            return (
              <div
                key={c.title}
                className='group flex gap-4 items-start rounded-xl border border-zinc-800 bg-bg-elev p-5 hover:border-accent/50 transition-all duration-200'
              >
                <div className='shrink-0 w-12 h-12 rounded-lg bg-accent/10 flex items-center justify-center text-accent text-xl group-hover:bg-accent/20 transition-colors'>
                  <Icon />
                </div>
                <div>
                  <h3 className='font-semibold text-white leading-tight'>{c.title}</h3>
                  <p className='text-accent text-sm font-mono mt-1'>{c.level}</p>
                  <p className='text-zinc-500 text-sm mt-1'>{c.issuer}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Certifications;
